export enum CashierConfigurationKeys {
  UserId = 'userId',
  SessionId = 'sessionId',
  MerchantId = 'merchantId',
  PaymentType = 'paymentType',
  Currency = 'currency',
  Bonus = 'bonus',
  TermsUrl = 'termsUrl',
  Platform = 'platform',
  Host = 'host',
  Language = 'language',
  AccountId = 'accountId',
  PgwMerchantId = 'pgwMerchantId',
  CustomerBalance = 'customerBalance',
  WebView = 'webView',
  Direction = 'direction',
  Country = 'country',
  OrderId = 'orderId',
  Amount = 'amount',
  InitialAmount = 'initialAmount',
  Window = 'window',
  Theme = 'theme',
  SubmitInitiator = 'submitInitiator',
}

export enum WindowNames {
  /*@TODO: make sure, is "PROVIDER_"-prefix required or not*/
  Iframe = 'PROVIDER_IFRAME',
  Window = 'PROVIDER_WINDOW',
}

export enum Versions {
  v1 = 'v1',
  v2 = 'v2',
  v3 = 'v3',
  v4 = 'v4',
}

export enum ColourThemes {
  Light = 'light',
  Dark = 'dark',
}

export enum Directions {
  Ltr = 'ltr',
  Rtl = 'rtl',
}

export enum SubmitInitiators {
  Self = 'self',
  Parent = 'parent',
}

export enum IntegrationThemes {
  Default = 'Default',
  Platform = 'Platform',
}

export enum DynamicScreens {
  FinalScreen = 'FinalScreen',
  ProcessingResult = 'ProcessingResult',
  PaymentForm = 'PaymentForm',
  ConfirmationForm = 'ConfirmationForm',
}
